// @flow

import React from "react"
import styles from "./styles.css"

import FontIcon from "react-toolbox/lib/font_icon/FontIcon"

const ArrowIcon = ( {
  invert,
  iconStyle,
  onClick,
  iconName = "arrow_drop_down",
}: {
invert: boolean,
iconStyle: any,
onClick: any,
iconName?: string,
} ) => (
  <div
    onClick={onClick}
    onKeyPress={onClick}
    role="button"
    tabIndex="0"
    className={styles.wrapper}
  >
    <FontIcon
      style={{
        transition: "transform 0.3s",
        outline: "none",
        userSelect: "none",
        margin: "auto",
        transform: invert ? "rotate(180deg)" : "initial",
        ...iconStyle,
      }}
      value={iconName}
    />
  </div>
)

export default ArrowIcon



// WEBPACK FOOTER //
// ./src/components/ArrowIcon/index.jsx